import { httpRequest } from "../../http";
import {Engagement} from "@models/engagement.model.ts";
import {EngagementSerializer} from "@models/serializers/engagementSerializer.ts";

export class CommandGetEngagement {
    async run(engagementId: number) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });

            return this.deserialize(response);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Engagement{
         const serializer = new EngagementSerializer();
         return serializer.deserialize(data);
     }
}

